import { Component, effect, inject, viewChild } from '@angular/core';
import { PopupModalHostDirective } from '@directives/popup-modal-host/popup-modal-host.directive';
import { PopupModalService } from '@services/popup-modal/popup-modal.service';

@Component({
  selector: 'app-popup-modal-shell',
  standalone: true,
  imports: [PopupModalHostDirective],
  templateUrl: './popup-modal-shell.component.html',
  styleUrl: './popup-modal-shell.component.scss',
})
export class PopupModalShellComponent {
  readonly popupModalService = inject(PopupModalService);

  private readonly popupModalHost = viewChild(PopupModalHostDirective);

  constructor() {
    effect(() => {
      const host = this.popupModalHost();

      if (!host) {
        return;
      }

      this.popupModalService.attachHost(host.viewContainerRef);
    });
  }
}
